<template>
  <div class="modal_card">
    <div class="header">
      <h4 class="title">
        {{ translate('comments.new_comment') }}
      </h4>
    </div>
    <div class="content">
      <form>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <sis-select
                v-model="visible"
                :options="visible_list"
                :placeholder="translate('comments.visible')"
                :label="translate('comments.visible')"
                :clearable="false"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label>{{ translate('comments.text_comment') }}</label>
              <textarea
                ref="comment"
                v-model="text_comment"
                rows="5"
                class="form-control border-input comment"
                :placeholder="translate('comments.text_comment')"
              />
            </div>
          </div>
        </div>
        <div class="text-center">
          <button
            class="btn btn-info btn-fill btn-wd"
            @click.prevent="add_comment"
            :disabled='disabled_btn'
          >
            {{ translate("comments.to_add") }}
          </button>
          <button
            type="submit"
            class="btn btn-danger btn-fill btn-wd"
            @click.prevent="cancel"
          >
            Cancel
          </button>
        </div>
        <div class="clearfix" />
      </form>
    </div>
  </div>
</template>
<script>

export default {
  name: "NewComment",
  props: ['params'],
  data () {
    return {
      disabled_btn: false,
      visible: 0,
      text_comment: ''
    }
  },
  mounted() {
    this.$refs.comment.focus() //Автофокус на тексте, после открытия модалки с комментарием
  },
  computed:{
    visible_list(){
      let list = []
      for (let filter of this.$store.getters.getCommentsFilters) {
        list.push({ label: this.translate(filter.name), id: filter.value})
      }
      this.visible = list[0].id
      return list
    }
  },
  methods: {
    cancel () {
      this.$emit('close')
    },
    add_comment(){
      this.disabled_btn = true
      let params = {...this.params}
      params.filter = this.visible
      params.text = this.text_comment

      this.$http.v1.addComment(params, () => {
        this.global_notify('info', this.translate('comments.new_comment_success'))
        this.$emit('update')
        this.$emit('close')
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  .modal_card{
    width: 100%;
    border-radius: 3px;
    box-shadow: 0 2px 2px rgba(204, 197, 185, 0.5);
    color: #252422;
    position: relative;
    border: 1px solid #ccc;
    min-height: 85px;
    background-color: #f8f8f8;
    padding: 10px;

    .header{
      .title{
        margin-top: 15px;
        text-align: center;
      }
    }
    .content{
      textarea{
        background-color: #fffcf5;
        border-radius: 4px;
        color: #66615b;
        font-size: 14px;
        transition: background-color 0.3s ease 0s;
        padding: 7px 18px;
        box-shadow: none;
        border: 1px solid #e8e8e8;
        height: 200px;
      }
    }
  }

</style>
